import axios from 'axios'
import * as vars from './vars';

export function getPaymentClientToken(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GeneratePaymentClientToken',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function hasPayed(meetingId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetClientPaymentStatus',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {meetingId: meetingId}
    })
}

export function sendNonce(nonce, deviceData, meetingId, promo, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/AuthorizeClientPayment',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            paymentNonce: nonce,
            deviceData: deviceData,
            meetingId: meetingId,
            promotionalCode: promo
        }
    })
}

export function updatePaymentMethod(method, data, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/AddPaymentMethod',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            method: method,
            [method]: data,
        }
    })
}

export function getPlaidLinkToken(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetPlaidLinkToken',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function getPayoutAccounts(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetInboundPaymentMethods',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function deletePayoutMethod(data, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/RemovePaymentMethod',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function setDefaultPayoutMethod(data, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/SetDefaultPaymentMethod',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function getEarnings(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetEarningsSummary',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function ssnOnFile(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetSSNStatus',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function setSSN(line1, line2, zipCode, ssn, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/SetSSN',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            line1: line1,
            line2: line2,
            zipCode: zipCode,
            ssn: ssn,
        }
    })
}

export function getPaymentHistory(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetAllUserPayments',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function activatePromotionCode(promotionalCode, meetingId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/ActivatePromotionCode?',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            promotionalCode: promotionalCode, meetingId: meetingId
        }
    })
}

// data = {
//   amountRequested: Double,
//   hoursWorked: Double (Optional),
//   memo: String (Optional),
// }
export function sendInvoice(contractId, invoice, jwt) {
    const data = invoice;
    data['contractId'] = contractId
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/transaction/SendInvoice`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function payInvoice(paymentNonce, deviceData, invoiceId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/transaction/AuthorizeClientPayment`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            type: "INVOICE",
            paymentNonce: paymentNonce,
            deviceData: deviceData,
            invoiceId: invoiceId
        }
    })
}

export function getInvoices(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/transaction/GetInvoices',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// data = {
//   action: String [ SETTLE | DISPERSE | REJECT | VOID ]
// }
export function updateInvoiceStatus(invoiceId, status, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/employment/UpdateInvoice/`,
        headers: {api_key: this.api_key, 'X-XSRF-TOKEN': this.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            invoiceId: invoiceId,
            status: status
        }
    })
}